var _path, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgHeroLeftMobile(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "eDw3NAts24j1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 200 200",
    shapeRendering: "geometricPrecision",
    textRendering: "geometricPrecision",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "eDw3NAts24j2",
    d: "M1087.69841,180.46811c19.29064,19.17793,31.23301,45.73926,31.23301,75.08989c0,58.4767-47.40473,105.88143-105.88143,105.88143s-105.88143-47.40473-105.88143-105.88143h.00001c0-58.4767,47.40473-105.88143,105.88143-105.88143.40052,0,.80053.00222,1.2.00666",
    transform: "matrix(.573747 0 0 0.573747-481.779599-46.625636)",
    fill: "none",
    stroke: "#9dc6c6",
    strokeWidth: 35,
    strokeDashoffset: 583.707435,
    strokeDasharray: 583.707435
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-647-.930497)",
    clipPath: "url(#eDw3NAts24j6)"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M823.959,499.699l46.608,44.203l45.004-46.264",
    fill: "none",
    stroke: "#002a2a",
    strokeWidth: 17,
    strokeDashoffset: 128.77796,
    strokeDasharray: 128.77796
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "eDw3NAts24j6"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 1145,
    height: 556,
    rx: 0,
    ry: 0,
    transform: "translate(.893799 0)",
    fill: "#fff"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHeroLeftMobile);
export default __webpack_public_path__ + "static/media/hero-left-mobile.7c20b5b4fa86f9e8983988a954418b32.svg";
export { ForwardRef as ReactComponent };